// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__v3GmB","type":"styles_type__3eL9q","choices":"styles_choices__1KPwd"};